import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2BulkLockParams,
  IIndirectTaxFilingV2BulkLockResponse,
  IIndirectTaxFilingV2MutationResult,
} from './types';

export async function bulkLockIndirectTaxFilingsV2({
  params,
  token,
}: {
  params: IIndirectTaxFilingV2BulkLockParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2BulkLockResponse>
> {
  try {
    const response = await fetcher(
      'new-sales-tax/filings-v2/lock/bulk',
      { method: 'POST', body: params },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error: json?.message || 'Failed to bulk approve filings',
      };
    }
    const data: IIndirectTaxFilingV2BulkLockResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to bulk approve filings',
    };
  }
}
